import { render, staticRenderFns } from "./FormUnitPrice.vue?vue&type=template&id=3bb942a2&scoped=true"
import script from "./FormUnitPrice.vue?vue&type=script&lang=js"
export * from "./FormUnitPrice.vue?vue&type=script&lang=js"
import style0 from "./FormUnitPrice.vue?vue&type=style&index=0&id=3bb942a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb942a2",
  null
  
)

export default component.exports